<template>
  <div class="fotocheck-container">
    <!-- Cara Frontal -->
    <div class="fotocheck-card front">
      <div class="geometric-pattern"></div>
      <div class="fotocheck-header">
        <!-- Usar SVG como logo -->
        <img src="http://localhost/sistema-gimnasio/api/imagenes/gym-login.svg" class="logo" alt="Logo" />
      </div>
      <div class="fotocheck-photo">
        <img :src="urlImagen(miembro.imagen)" class="img-member" />
      </div>
      <div class="fotocheck-nombre">{{ miembro.nombre }}</div>
      <div class="fotocheck-rol">MIEMBRO</div>
      <div class="fotocheck-id">
        <span class="dots-left">● ● ● ● </span>
        <span class="id-text"><span class="label">ID:</span> {{ miembro.matricula }}</span>
        <span class="dots-right">● ● ● ● </span>
      </div>
      <div class="fotocheck-footer">
        <div class="membresia-text">{{ miembro.membresia || 'Mensual' }}</div>
        <div class="gym-name">{{ nombreGimnasio }}</div>
      </div>
    </div>

    <!-- Cara Trasera -->
    <div class="fotocheck-card back">
      <div class="geometric-pattern"></div>
      <div class="back-contact">
        <div class="contact-row">
          <v-icon color="#00d6f7" size="20">mdi-email</v-icon>
          <span>{{ emailGimnasio }}</span>
        </div>
        <div class="contact-row">
          <v-icon color="#00d6f7" size="20">mdi-phone</v-icon>
          <span>{{ telefonoGimnasio }}</span>
        </div>
        <div class="contact-row">
          <v-icon color="#00d6f7" size="20">mdi-map-marker</v-icon>
          <span>{{ direccionGimnasio }}</span>
        </div>
      </div>
      <div class="back-dates">
        <div class="date-row">
          <span class="dots-left">● ● ● ● ●</span>
          <span class="date-content">
            <span class="label">UNIDO:</span> {{ fechaFormateada(miembro.fechaRegistro) }}
          </span>
          <span class="dots-right">● ● ● ● ●</span>
        </div>
        <div class="date-row">
          <span class="dots-left">● ● ● ● ●</span>
          <span class="date-content">
            <span class="label">EXPIRA:</span> {{ fechaFormateada(miembro.fechaFin) }}
          </span>
          <span class="dots-right">● ● ● ● ●</span>
        </div>
      </div>
      <div class="back-qr-section">
        <div class="qr-wrapper">
          <img :src="'https://api.qrserver.com/v1/create-qr-code/?size=160x160&data=' + miembro.matricula" class="qr-img" />
        </div>
      </div>
      <div class="website-text">
        <v-icon color="#1877F3" size="22" class="mr-1" style="vertical-align: middle;">mdi-facebook</v-icon>
        <span>{{ facebookGimnasio }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Utiles from '../../Servicios/Utiles'
import HttpService from '../../Servicios/HttpService'

export default {
  name: "CredencialMiembro",
  props: ["matricula", "miembro"],
  data: () => ({
    nombreGimnasio: "---",
    telefonoGimnasio: "---",
    direccionGimnasio: "---",
    facebookGimnasio: "Live fit",
    emailGimnasio: "contacto@livefit.me"
  }),
  mounted() {
    this.obtenerDatosGimnasio();
    // Automatically trigger print dialog when the component is mounted
    this.$nextTick(() => {
      window.print();
    });
  },
  methods: {
    urlImagen(imagen) { return Utiles.generarURL(imagen, 'miembros'); },
    fechaFormateada(fecha) {
      if (!fecha) return "---";
      const f = fecha.split(" ")[0];
      const [y, m, d] = f.split("-");
      return `${d}.${m}.${y.slice(2)}`;
    },
    async obtenerDatosGimnasio() {
      try {
        const res = await HttpService.obtenerConDatos({ metodo: "obtener" }, "ajustes.php");
        if (res) {
          this.nombreGimnasio = res.nombre && res.nombre.trim() ? res.nombre : "---";
          this.telefonoGimnasio = res.telefono && res.telefono.trim() ? res.telefono : "---";
          this.direccionGimnasio = res.direccion && res.direccion.trim() ? res.direccion : "---";
          // Si tienes el facebook en la BD, usa res.facebook || "Live fit"
          // this.facebookGimnasio = res.facebook && res.facebook.trim() ? res.facebook : "Live fit";
        }
      } catch (e) {
        // Si hay error, deja los valores por defecto
      }
    }
  },
  watch: {
    miembro: {
      handler() { this.obtenerDatosGimnasio(); },
      immediate: true
    }
  }
}
</script>

<style scoped>
.fotocheck-container{
  display:flex;
  flex-direction:row;
  gap:50px;
  justify-content:center;
  align-items:flex-start;
  padding:40px 0;
  font-family:'Arial Black','Helvetica','Arial',sans-serif;
}

/* Paleta */
:root{
  --morado:#7f43f4;
  --celeste:#00d6f7;
  --blanco:#ffffff;
  --oscuro:#0f0b16;
  --oscuro2:#171125;
}

.fotocheck-card{
  width:350px;
  height:550px;
  position:relative;
  overflow:hidden;
  border-radius:16px;
  background: linear-gradient(180deg, var(--oscuro) 0%, var(--oscuro2) 100%);
  box-shadow: 0 18px 55px rgba(0,0,0,.65);
  display:flex;
  flex-direction:column;
  align-items:center;
  border:1px solid rgba(255,255,255,.06);
}

/* patrón sutil morado */
.geometric-pattern{
  position:absolute;
  inset:0;
  opacity:.12;
  background-image:
    linear-gradient(45deg, transparent 48%, rgba(127,67,244,.9) 48%, rgba(127,67,244,.9) 52%, transparent 52%),
    linear-gradient(-45deg, transparent 48%, rgba(127,67,244,.9) 48%, rgba(127,67,244,.9) 52%, transparent 52%);
  background-size: 64px 64px;
  background-position: 0 0, 32px 32px;
  pointer-events:none;
  z-index:0;
}

/* brillos laterales tipo “chevron” */
.fotocheck-card::before{
  content:"";
  position:absolute;
  inset:-40px -80px auto -80px;
  height:240px;
  background:
    radial-gradient(circle at 20% 20%, rgba(0,214,247,.18), transparent 55%),
    radial-gradient(circle at 70% 40%, rgba(127,67,244,.18), transparent 60%);
  filter: blur(2px);
  z-index:0;
}

.fotocheck-header{
  width:100%;
  display:flex;
  justify-content:center;
  align-items:center;
  padding:24px 0 10px 0;
  position:relative;
  z-index:2;
}

.logo{
  height:46px;
  max-width:190px;
  object-fit:contain;
  filter: drop-shadow(0 6px 18px rgba(0,0,0,.35));
}

/* FOTO: marco celeste + acento esquina morada */
.fotocheck-photo{
  margin:18px auto 18px auto;
  width:165px;
  height:165px;
  background: var(--blanco);
  border-radius:10px;
  border:6px solid var(--celeste);
  display:flex;
  align-items:center;
  justify-content:center;
  overflow:hidden;
  position:relative;
  z-index:2;
  box-shadow: 0 10px 25px rgba(0,0,0,.35);
}

/* acento tipo “L” en esquina (similar plantilla) */
.fotocheck-photo::after{
  content:"";
  position:absolute;
  right:-6px;
  bottom:-6px;
  width:58px;
  height:58px;
  border-right:10px solid var(--morado);
  border-bottom:10px solid var(--morado);
  border-radius:0 0 10px 0;
  opacity:.95;
}

.img-member{
  width:100%;
  height:100%;
  object-fit:cover;
}

.fotocheck-nombre{
  color:var(--blanco);
  font-size:1.85rem;
  font-weight:900;
  text-align:center;
  margin:12px 18px 6px 18px;
  letter-spacing:1px;
  text-transform:uppercase;
  position:relative;
  z-index:2;
  line-height:1.15;
  text-shadow: 0 10px 22px rgba(0,0,0,.45);
}

.fotocheck-rol{
  color:var(--celeste);
  font-size:1.25rem;
  font-weight:900;
  text-align:center;
  margin-bottom:20px;
  letter-spacing:5px;
  position:relative;
  z-index:2;
  text-transform:uppercase;
}

.fotocheck-id{
  display:flex;
  align-items:center;
  justify-content:center;
  gap:10px;
  margin-bottom:18px;
  position:relative;
  z-index:2;
}

.dots-left,.dots-right{
  color:var(--celeste);
  font-size:.52rem;
  letter-spacing:3px;
  opacity:.95;
}

.id-text{
  color:var(--blanco);
  font-size:1.05rem;
  font-weight:900;
  letter-spacing:.6px;
  white-space:nowrap;
}

.label{
  color:var(--celeste);
  font-weight:900;
}

/* Franja inferior inclinada (celeste+blanco) tipo plantilla */
.fotocheck-footer{
  position:absolute;
  bottom:0;
  width:100%;
  height:150px;
  z-index:1;
}

/* capa celeste inclinada */
.fotocheck-footer::before{
  content:"";
  position:absolute;
  inset:0;
  background: var(--celeste);
  clip-path: polygon(0 45%, 100% 25%, 100% 100%, 0 100%);
}

/* capa blanca encima creando separación */
.fotocheck-footer::after{
  content:"";
  position:absolute;
  inset:0;
  background: var(--blanco);
  opacity:.95;
  clip-path: polygon(0 58%, 100% 40%, 100% 100%, 0 100%);
}

.membresia-text{
  position:absolute;
  left:0;
  right:0;
  bottom:64px;
  text-align:center;
  font-size:1.15rem;
  font-weight:900;
  letter-spacing:1px;
  color: var(--morado);
  z-index:2;
  text-transform:uppercase;
}

.gym-name{
  position:absolute;
  left:0;
  right:0;
  bottom:28px;
  text-align:center;
  font-size:1.55rem;
  font-weight:900;
  letter-spacing:3px;
  color: #0f0b16;
  z-index:2;
  text-transform:uppercase;
}

/* =================== REVERSO =================== */
.back-contact{
  width:100%;
  margin-top:28px;
  margin-bottom:22px;
  display:flex;
  flex-direction:column;
  align-items:flex-start;
  padding-left:42px;
  gap:14px;
  position:relative;
  z-index:2;
}

.contact-row{
  color:var(--blanco);
  font-size:1.03rem;
  font-weight:800;
  display:flex;
  align-items:center;
  gap:12px;
}

.back-dates{
  width:100%;
  margin-bottom:26px;
  display:flex;
  flex-direction:column;
  gap:14px;
  position:relative;
  z-index:2;
  padding:0 18px;
}

.date-row{
  display:flex;
  align-items:center;
  justify-content:center;
  gap:10px;
}

.date-content{
  color:var(--blanco);
  font-size:1rem;
  font-weight:900;
  white-space:nowrap;
  letter-spacing:.5px;
}

.back-qr-section{
  width:100%;
  display:flex;
  justify-content:center;
  position:relative;
  z-index:2;
  margin-bottom:20px;
}

/* QR con “placa” celeste tipo plantilla */
.qr-wrapper{
  background: var(--celeste);
  padding:22px 26px 26px 26px;
  border-radius:14px;
  box-shadow: 0 12px 28px rgba(0,0,0,.35);
  position:relative;
}

/* pequeño acento morado */
.qr-wrapper::after{
  content:"";
  position:absolute;
  left:-10px;
  top:-10px;
  width:42px;
  height:42px;
  border-left:10px solid var(--morado);
  border-top:10px solid var(--morado);
  border-radius:14px 0 0 0;
  opacity:.95;
}

.qr-img{
  width:140px;
  height:140px;
  background: var(--blanco);
  display:block;
  border-radius:10px;
}

.website-text{
  color:var(--blanco);
  font-weight:900;
  font-size:1.15rem;
  letter-spacing:1px;
  text-align:center;
  position:relative;
  z-index:2;
  text-transform:uppercase;
  padding-bottom:18px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Miembros/CredencialMiembro.vue